import { Clear, Save } from "@mui/icons-material"
import { IconButton, InputAdornment, TextField, type TextFieldProps } from "@mui/material"
import { KeyboardEvent, useState } from "react"
import OPTooltip from "components/material/tooltip"
import { isEnterKey, isEscapeKey } from "helpers/keyboard"

export type SaveableTextFieldProps = TextFieldProps & {
  onCancel: () => void
  onSave: (text: string) => void
  isSaving: boolean
}

export default function SaveableTextField({ onCancel, onSave, value: initialValue, isSaving, ...props }: SaveableTextFieldProps) {
  const [value, setValue] = useState(initialValue)

  function handleSave() {
    onSave(value?.toString() ?? "")
  }

  function handleKeyDown(e: KeyboardEvent<HTMLInputElement>) {
    if (isEnterKey(e)) {
      handleSave()
    }
    if (isEscapeKey(e)) {
      onCancel()
    }
  }

  return <TextField
    slotProps={{
      input: {
        endAdornment: <InputAdornment position="end">
          <OPTooltip title="Cancel">
            <IconButton onClick={onCancel} color="warning" disabled={isSaving}><Clear /></IconButton>
          </OPTooltip>
          <OPTooltip title="Save">
            <IconButton onClick={handleSave} color="primary" loading={isSaving}><Save /></IconButton>
          </OPTooltip>
        </InputAdornment>,
      },
    }}
    {...props}
    value={value}
    onChange={(e) => setValue(e.target.value)}
    disabled={isSaving}
    onKeyDown={handleKeyDown}
  />
}
